<script>
    import { t, locale } from "$lib/translations";
    import Play from "$lib/images/play.svg";
    import Video from "$lib/images/video.svg";
    import MainImage from "$lib/images/main_image.webp";

    function onPress() {
        window.dataLayer = window.dataLayer || [];
        if ($locale === "ua") return;
        dataLayer.push({
            event: "step_1_succes",
        });
    }
</script>

<svelte:head>
    <link rel="preload" href={MainImage} as="image" />
</svelte:head>

<section>
    <div class="main-section">
        <div class="main-image">
            <div class="image">
                <img src={MainImage} alt="UnrealRP" />
            </div>
            <div class="unreal-info">
                <div class="text-present">
                    <h1 class="large">{$t("home.start_game")}</h1>
                    <!--					<span class="small">{t('main.start-game')}</span>-->
                </div>
                <div class="buttons">
                    <a href="/{$locale}/how-to-play" on:click={onPress}>
                        <div class="play-btn">
                            <button class="btn btn-primary">
                                <div class="icon">
                                    <img src={Play} alt="Play" />
                                </div>
                                <div class="text">
                                    {$t("home.start_game_button")}
                                </div>
                            </button>
                        </div>
                    </a>
                    <div class="video-btn">
                        <a href={$t("home.video_link")} target="_blank">
                            <button class="btn"><img src={Video} alt="Video" /></button>
                        </a>
                    </div>
                </div>
                <div class="text-tagline">
                    {@html $t("home.tagline")}
                </div>
            </div>
        </div>
    </div>
</section>

<style lang="scss">
    @import "/src/lib/scss/main";

    section {
        background-image: url("/src/lib/images/pattern.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-attachment: local;
        background-size: contain;
        margin-bottom: 10rem;
        margin-top: 2rem;
        padding: 5px !important;
    }

    .main-section {
        position: relative;
        display: flex;
        justify-content: center;
    }

    .main-image {
        position: relative;
        display: flex;
        justify-content: center;

        & > .image {
            animation: animImage infinite 4s;
            transition: transform 0.3s;
            width: 45rem;

            @keyframes animImage {
                0% {
                    transform: translateY(0);
                }
                50% {
                    transform: translateY(5px);
                }
                100% {
                    transform: translateY(0);
                }
            }
        }
    }

    .unreal-info {
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        & > .text-present {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: white;
            //line-height: 20px;
            text-align: center;
            gap: 5px;
            text-transform: uppercase;

            & > .large {
                font-size: 14pt;
                font-weight: 900;
                font-style: italic;
            }

            & > .small {
                font-size: 11pt;
                opacity: 0.6;
                font-weight: 300;
            }
        }

        & > .buttons {
            display: flex;
            align-items: center;
            gap: 1rem;
            margin-top: 10px;
            margin-bottom: 25px;

            & > a {
                text-decoration: none;

                & > .play-btn {
                    width: 282px;
                    height: 64px;

                    & > button {
                        padding: 10px;
                    }
                }
            }

            & > .video-btn {
                width: 64px;
                height: 64px;

                & > a {
                    & > button {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 1px solid rgba(255, 251, 239, 0.2);
                        border-radius: 4px;
                        transition:
                            box-shadow $default-transition-time,
                            border $default-transition-time;
                        padding: 10px;

                        & > img {
                            width: 2rem;
                        }
                    }

                    &:hover {
                        & > button {
                            box-shadow: 0 0 5px 1px #fff;
                            border: 1px solid #fff;
                        }
                    }
                }
            }
        }

        & > .text-tagline {
            text-transform: uppercase;
            color: white;
            font-style: italic;
            font-weight: 300;
            text-align: center;
            line-height: 20px;
            width: 30rem;
            font-size: 18px;

            & > .yellow {
                color: #fed500;
                font-weight: 900;
            }
        }
    }

    @media screen and (max-width: 600px) {
        .image {
            width: 100% !important;

            img {
                content: url("$lib/images/main_image_mobile.webp");
            }
        }
    }

    @media screen and (max-width: 550px) {
        .unreal-info {
            bottom: -5rem !important;
        }
        .text-tagline {
            width: auto !important;
            font-size: 11pt !important;
            line-height: 120% !important;
        }
        .play-btn {
            width: 240px !important;

            & > .icon {
                width: 20px;
            }

            & > .text {
                font-size: 14px;
            }
        }
        .large {
            font-size: 15pt !important;
        }
        .small {
            font-size: 12pt !important;
        }
    }

    @media screen and (max-width: 400px) {
        .play-btn {
            height: 50px !important;
        }
        .video-btn {
            height: 50px !important;
            width: 50px !important;

            & > button > img {
                width: 30px !important;
            }
        }
    }

    @media screen and (max-width: 380px) {
        .unreal-info {
            bottom: -10rem !important;
        }
        .play-btn {
            width: 100% !important;
        }
        .text-tagline {
            width: 70% !important;
        }
        .text-present {
            width: 90% !important;
        }
    }
</style>
